import { PRODUCT_NAME_TO_ID_MAP } from "@/helpers/constants";

import type { IPlacementTableRow } from "@/models/offers";
import type { PlacementFilters } from "@/models/placement";

export const isValidForSubmittedPlacements = (
  placement: IPlacementTableRow,
  filters?: PlacementFilters
) => {
  // Filter by product type
  if (filters?.selectedProductTypes?.length) {
    const placementProductType = placement.product_type;

    if (!placementProductType) {
      return true;
    }

    const placementProductId =
      PRODUCT_NAME_TO_ID_MAP[
        placementProductType.toLowerCase().replace(/ /g, "_")
      ];

    if (!placementProductId) {
      return true;
    }

    if (!filters.selectedProductTypes.includes(placementProductId)) {
      return false;
    }
  }

  if (filters?.selectedStatuses?.length) {
    const placementStatus = String(placement.status);
    if (!filters.selectedStatuses.includes(placementStatus)) {
      return false;
    }
  }

  return true;
};
